import { ClassNames } from '@emotion/react';
import { useMemo } from 'react';
import AnimateHeight from 'react-animate-height';

/**
 * A simple component to hide and show children content.
 *
 * Utilitizes AnimateHeight to animate the visibility change.
 */
export const Collapse: React.FC<{
    visible: boolean;
    noAnimationDelay: boolean;
}> = ({ children, visible, noAnimationDelay }) => {
    const animationDelay = useMemo(() => {
        if (noAnimationDelay) {
            return 0;
        }

        return visible ? 400 : 0;
    }, [visible, noAnimationDelay]);

    return (
        <ClassNames>
            {({ css }) => (
                <AnimateHeight
                    duration={visible ? 500 : 300}
                    contentClassName={css({})}
                    height={visible ? 'auto' : 0}
                    delay={animationDelay}
                >
                    <div>{children}</div>
                </AnimateHeight>
            )}
        </ClassNames>
    );
};
